<template>
    <div class="single__filters">
        <div class="single__filters__dropdown">
            <p>
                {{ i18n.filterBy }}
            </p>
            <ResourceSelect
                id="resource-topic-filter"
                :model-value="topic"
                :terms="topics"
                :label="i18n.selectTopic"
                :all-label="i18n.allTopics"
                :clear-label="i18n.clearTopic"
                :clear-url="clearTopicUrl"
                :icons="icons"
                @update:model-value="$emit('update:topic', $event)"
            />
            <ResourceSelect
                id="resource-species-filter"
                :model-value="species"
                :terms="speciesTerms"
                :label="i18n.selectSpecies"
                :all-label="i18n.allSpecies"
                :clear-label="i18n.clearSpecies"
                :clear-url="clearSpeciesUrl"
                :icons="icons"
                @update:model-value="$emit('update:species', $event)"
            />
        </div>
        <div class="page404__search">
            <form class="search__form" :action="pageUrl" method="get" @submit.prevent="submit">
                <input v-if="topic" type="hidden" name="resource_topic" :value="topic">
                <input v-if="species" type="hidden" name="resource_species" :value="species">
                <input v-if="tag" type="hidden" name="resource_tag" :value="tag">
                <button type="submit" v-html="submitContent"></button>
                <label class="vh" for="resource-search">{{ i18n.search }}</label>
                <input
                    id="resource-search"
                    v-model="term"
                    type="search"
                    name="resource_search"
                    :placeholder="i18n.search"
                >
            </form>
        </div>
        <a
            v-if="hasFilters"
            class="single__filters__reset"
            :href="pageUrl"
            @click.prevent="onReset"
        >
            <span v-html="icons.clearAll"></span>
            {{ i18n.resetFilters }}
        </a>
    </div>
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, ref, watch } from 'vue'
import debounce from 'lodash/debounce'

import ResourceSelect from './ResourceSelect.vue'

const props = defineProps({
    topic: { type: String, default: '' },
    species: { type: String, default: '' },
    tag: { type: String, default: '' },
    search: { type: String, default: '' },
    topics: { type: Array, default: () => [] },
    speciesTerms: { type: Array, default: () => [] },
    hasFilters: { type: Boolean, default: false },
    pageUrl: { type: String, default: '' },
    clearTopicUrl: { type: String, default: '' },
    clearSpeciesUrl: { type: String, default: '' },
    icons: { type: Object, default: () => ({}) },
    i18n: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['update:topic', 'update:species', 'update:search', 'reset'])

const focusFilter = (id) => {
    const field = document.getElementById(id)

    if (!field) {
        return
    }

    const selection = field.parentElement?.querySelector('.select2-selection')

    if (selection instanceof HTMLElement) {
        selection.focus()
        return
    }

    field.focus()
}

const onReset = () => {
    emit('reset')
    nextTick(() => focusFilter('resource-topic-filter'))
}

const term = ref(props.search)

const submitContent = computed(
    () => `<div class="vh">${props.i18n.search || ''}</div>${props.icons.search || ''}`
)

const normalized = (value) => (value || '').trim().replace(/\s+/g, ' ')

const emitSearch = debounce(() => {
    const next = normalized(term.value)

    if (next !== props.search) {
        emit('update:search', next)
    }
}, 400)

watch(term, emitSearch)

watch(() => props.search, (value) => {
    if (value !== normalized(term.value)) {
        emitSearch.cancel()
        term.value = value
    }
})

const submit = () => {
    emitSearch.cancel()

    const next = normalized(term.value)

    if (next !== props.search) {
        emit('update:search', next)
    }
}

onBeforeUnmount(() => emitSearch.cancel())
</script>
